<script>
  import Alert from "../Alerts/Alert.svelte";
  import {
    useEProtectorLicenseAuthenticationResultQuery
  } from "../../hooks/license/useEProtectorLicenseAuthenticationResultQuery.js";
  import GeneralButton from "../button/GeneralButton.svelte";
  import ManageLicenseAuthenticationDialog
    from "../../routes/admin/server/ManageLicenseAuthenticationDialog/index.svelte";

  const queryResult = useEProtectorLicenseAuthenticationResultQuery()

  let openedDialog = null
</script>

{#if $queryResult.data && !$queryResult.data.validityPeriod.isValid.ok}
  {#if $queryResult.data.validityPeriod.isValid.reason === "expired"}
    <Alert type="error">
      <div style="display: flex; justify-content: space-between; flex-wrap: wrap; width: 100%; gap: 1rem">
        このサーバにはe-プロテクタがインストールされていますが、期限切れになっています。
        <div style="margin-left: auto">
          <GeneralButton onClick={() => openedDialog = "manageLicenseAuthentication"}>
            e-プロテクタを更新 / キャンセルする
          </GeneralButton>
        </div>
      </div>
    </Alert>
  {/if}
  {#if $queryResult.data.validityPeriod.isValid.reason === "notStarted"}
    <Alert type="error">
      開始前
    </Alert>
  {/if}
{/if}
{#if openedDialog === "manageLicenseAuthentication"}
  <ManageLicenseAuthenticationDialog
    onClose={() => openedDialog = null}
  />
{/if}
